import { Theme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(({ breakpoints }: Theme) => ({
  cardPlaceholderWrapper: {
    padding: '0 16px',
    marginBottom: 24,
    [breakpoints.up('md')]: {
      padding: '0 40px',
      marginBottom: 32,
    },
    [breakpoints.up('lg')]: {
      padding: '0 75px',
    },
  },
}));
